import { api } from "@signet/web-kit";
import type { Status, Stream, Target } from "../shared/targets.ts";

/* What the CB Stats page reads from /api/m/cbstats, typed once. Mirrors server/store.ts. */

export const BASE = "/api/m/cbstats";

export type { Status, Stream, Target } from "../shared/targets.ts";
export type DayCell = { minutes: number; peak: number; streams: number; counted: boolean };
export type Progress = { status: Status; done: number; need: number; label: string; time: { minutes: number; need: number; label: string } | null; needs: string | null; late: boolean };

export type WeekRow = {
  account: string;
  creator: string;
  username: string;
  target: Target;
  own: boolean;
  schedule: number[];
  days: (DayCell | null)[];
  streams: number;
  minutes: number;
  peak: number | null;
  avg: number | null;
  followersGained: number;
  progress: Progress;
  status: Status;
  trackedFrom: string | null;
  lastWeek: { done: number; need: number; label: string; minutes: number; status: Status; tracked: boolean };
  live: boolean;
};

export type Week = { week: string; today: string; current: boolean; daysLeft: number; lastSweep: string | null; target: Target; rows: WeekRow[] };

export type History = {
  account: string;
  creator: string;
  username: string;
  addedAt: string;
  target: Target;
  weeks: { week: string; status: Status; done: number; need: number; label: string; minutes: number; tracked: boolean }[];
  streams: (Stream & { counted: boolean })[];
};

export type SetupCreator = {
  creator: string;
  usernames: { id: string; username: string; addedAt: string; lastLive: string | null }[];
  target: Target | null;
  days: number[];
  avgPeak: number | null;
  streams: number;
};
export type Setup = { target: Target; creators: SetupCreator[] };

export type Account = { id: string; creator: string; username: string; addedAt: string; addedBy: string | null; lastLive: string | null };

export const cbKeys = {
  all: ["cbstats"] as const,
  week: (week: string) => ["cbstats", "week", week] as const,
  history: (id: string) => ["cbstats", "history", id] as const,
  accounts: ["cbstats", "accounts"] as const,
  setup: ["cbstats", "setup"] as const,
};

export const fetchWeek = (week?: string) => api<Week>(`${BASE}/week${week ? `?${new URLSearchParams({ week })}` : ""}`);
export const fetchHistory = (id: string) => api<History>(`${BASE}/accounts/${encodeURIComponent(id)}/history`);
export const fetchAccounts = () => api<{ accounts: Account[] }>(`${BASE}/accounts`);
export const addAccount = (input: { creator: string; username: string }) => api<{ account: Account }>(`${BASE}/accounts`, { body: input });
export const fetchSetup = () => api<Setup>(`${BASE}/setup`);
export const saveSetup = (creator: string, input: { target: Target; days: number[] }) =>
  api<{ creator: SetupCreator }>(`${BASE}/setup/${encodeURIComponent(creator)}`, { method: "PUT", body: input });
export const clearSetup = (creator: string) => api(`${BASE}/setup/${encodeURIComponent(creator)}`, { method: "DELETE" });
export const removeAccount = (id: string) => api(`${BASE}/accounts/${encodeURIComponent(id)}`, { method: "DELETE" });

export const roomUrl = (username: string) => `https://chaturbate.com/${encodeURIComponent(username)}/`;
export const count = (n: number) => n.toLocaleString("en-AU");
